/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */
import { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { MeContext } from 'contexts/me'
import Skeleton from 'react-loading-skeleton'
import { moneyFormat } from 'utils'

// API
import { getBalance } from 'api/bank'

// ASSETS
import {
  ClosedEye,
  MastercardIcon,
  OpenEye,
  SimpleArrowIcon,
  WayniIcon
} from 'assets/icons'

import cardBG from 'assets/images/waynicard-bg.png'

const Balance = () => {
  const [balanceIsLoading, setBalanceIsLoading] = useState(false)
  const [balance, setBalance] = useState(false)
  const [dataIsHidden, setDataIsHidden] = useState(true)

  const { me } = useContext(MeContext)

  // retrieve state from storage
  useEffect(() => {
    const data = sessionStorage.getItem('is_hidden')
    if (data !== null) setDataIsHidden(JSON.parse(data))
  }, [])

  // if user is active gets their data:
  useEffect(() => {
    if (me?.user?.status === 'ACTIVE' && !dataIsHidden) {
      // BALANCE DATA
      setBalanceIsLoading(true)
      getBalance()
        .then((res) => setBalance(res.balance))
        .finally(() => setBalanceIsLoading(false))
    }
  }, [me, dataIsHidden])

  const handleButton = () => {
    const newState = !dataIsHidden
    setDataIsHidden(newState)
    sessionStorage.setItem('is_hidden', newState)
  }

  const navigate = useNavigate()

  function renderBalance() {
    if (balanceIsLoading) {
      return <div className='h-[25px]' />
    }

    if (dataIsHidden) {
      return '**********'
    }

    if (balance) {
      return moneyFormat(balance)
    }

    return null
  }

  return (
    <section className='grid rounded-xl shadow-waynicard-2 grid-cols-[1fr_min-content] grid-rows-[min-content_min-content]'>
      <div className='h-[5.5rem] w-full rounded-t-xl col-start-1 col-end-3 rounded-b-xl overflow-hidden row-start-1 row-end-4 z-1 shadow-waynicard-1'>
        <img src={cardBG} className='!object-cover -mt-8' alt='' />
      </div>
      {/* BALANCE */}
      <div className='text-white col-start-1 col-end-3 row-start-1 row-end-2 z-2 mx-2 mt-2 mb-4 font-bold flex items-start justify-between'>
        <div className='w-5/6'>
          <h4 className='text-2xs font-medium mb-3 pt-1'>Saldo disponible</h4>
          <p
            className={`leading-tight ${
              parseInt(balance, 10) >= 100000 ? 'text-2xl' : 'text-3xl'
            }`}
          >
            {renderBalance()}
          </p>
        </div>
        <button type='button' onClick={() => handleButton()}>
          {dataIsHidden ? <ClosedEye /> : <OpenEye />}
        </button>
      </div>
      {/* BUTTON */}
      <button
        type='button'
        onClick={() => navigate('/mis-tarjetas')}
        className='text-white col-start-1 col-end-3 row-start-3 row-end-4 z-0 px-4 font-bold flex justify-between items-center bg-purple-900 pt-5 -mt-3 py-2 rounded-b-xl'
      >
        <div className='flex items-baseline gap-6'>
          <p className='text-2xs'>Ir a mis tarjetas</p>
          <SimpleArrowIcon stroke='white' />
        </div>
        <div className='flex gap-3 items-center'>
          <WayniIcon className='w-[1.375rem] h-3 fill-white' />
          <MastercardIcon className='w-7 h-5' />
        </div>
      </button>
    </section>
  )
}

export default Balance
